import clsx from 'clsx'

export const OuterTagStyledDiv = ({ children }) => (
  <div className="relative group hover:bg-neutral-10 dark:hover:bg-neutral-80">
    {children}
    <div data-testid="inactive-tag-hover-div" className="absolute inset-0 opacity-0 bg-neutral-10 dark:bg-neutral-95 group-hover:opacity-100" />
  </div>
)

export const InnerTagStyledDiv = ({ children, active, level }) => (
  <div data-testid="inner-tag-styled-div"
    className={clsx(
      'font-semibold relative z-10',
      level === 0 ? 'ml-7 mr-[18px]' : 'ml-5 mr-1.5',
      active ? 'hover:bg-neutral-20 dark:hover:bg-neutral-90 rounded' : '!mr-0',
    )}>
    {children}
  </div>
)

export const NavItemStyledDiv = ({ operation, lastItem, index, active, level, children, operationsLength, isSelected }) => (
  <div className={clsx(level === 0 ? 'ml-[38px] mr-[18px]' : 'ml-[30px] mr-1.5', !active && '!mr-0')}>
    <div
      className={clsx('relative border-l border-l-neutral-40 dark:border-l-neutral-60 last:border-none group z-40', lastItem && 'last-item')}
      key={operation.operationId || operation.id}
    >
      <div className={clsx('font-sans absolute text-neutral-40 dark:text-neutral-60 z-40 top-[5px] -left-[1px]', active && 'group-hover:invisible', isSelected && 'invisible')}>
        -
      </div>
      <div className="relative z-40">
        {index !== operationsLength - 1 && <div className="left-border" />}
        {children}
      </div>
      {!active && <div
        data-testid="inactive-operation-hover-div"
        className={clsx('absolute z-0 opacity-0 bg-neutral-10 dark:bg-neutral-95 group-hover:opacity-100 top-0 bottom-0',
          level === 0 ? '-left-[38px] -right-[18px]' : '-left-[30px] -right-1.5',
          !active && '!right-0'
        )}
      />}
    </div>
  </div>
)